export const gestureThrottle = <T = unknown>(
  action: (...args: any[]) => T,
  threshold = 100,
  resetDelay = 150,
  animationDuration = 300
) => {
  let accumulatedScroll = 0;
  let resetTimeout: NodeJS.Timeout | undefined = undefined;
  let isAnimating = false;

  return (scroll: number, ...args: any[]) => {
    if (isAnimating) {
      return;
    }

    accumulatedScroll += scroll;

    if (resetTimeout) {
      clearTimeout(resetTimeout);
    }

    const crossedThreshold = Math.abs(accumulatedScroll) >= threshold;

    if (crossedThreshold) {
      action(accumulatedScroll, ...args);
      accumulatedScroll = 0;
      isAnimating = true;

      setTimeout(() => {
        isAnimating = false;
      }, animationDuration);

      return;
    }

    resetTimeout = setTimeout(() => {
      accumulatedScroll = 0;
      resetTimeout = undefined;
    }, resetDelay);
  };
};
